import React from "react";

export const MenuBar = () => {
  return (
    <div className="menu-container max-width ">
      <ul className="items">
        <li className="is_active">
          <a href="/">PSG.FR</a>
        </li>
        <li>
          <a href="/">ENTRADAS</a>
        </li>
        <li>
          <a href="/">TIENDA</a>
        </li>
        <li>
          <a href="/">MYPARIS</a>
        </li>
        <li>
          <a href="/">TOUR DEL ESTADIO</a>
        </li>
      </ul>
    </div>
  );
};
